import { render, staticRenderFns } from "./RPQuestionnarieDetails.vue?vue&type=template&id=124a0844"
import script from "./RPQuestionnarieDetails.vue?vue&type=script&lang=js"
export * from "./RPQuestionnarieDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports